// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Notification = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Notification = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Notification = _exports.Notification = function Notification(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.8029 16.4588C11.8771 16.588 11.8763 16.748 11.8013 16.8763C11.4213 17.5272 10.7479 17.9163 9.99959 17.9163C9.25126 17.9163 8.57793 17.5272 8.19793 16.8763C8.12293 16.748 8.12209 16.588 8.19626 16.4588C8.27043 16.3297 8.40793 16.2497 8.55793 16.2497H11.4413C11.5904 16.2497 11.7279 16.3297 11.8029 16.4588ZM16.9921 14.7397C16.9763 14.7205 15.4121 12.7347 15.4121 10.4163V7.4955C15.4121 4.51134 12.9838 2.08301 9.99959 2.08301C7.01543 2.08301 4.58709 4.51134 4.58709 7.4955V10.4163C4.58709 12.7338 3.02376 14.7197 3.0071 14.7397C2.9071 14.8647 2.88793 15.0363 2.9571 15.1805C3.02626 15.3247 3.17209 15.4163 3.33209 15.4163H16.6654C16.8254 15.4163 16.9713 15.3247 17.0404 15.1805C17.1113 15.0355 17.0913 14.8647 16.9921 14.7397Z",
      fill: "currentColor"
    }));
  };
});
